import { render } from "./MainIndicators.vue?vue&type=template&id=c2bceb34"
import script from "./MainIndicators.vue?vue&type=script&lang=js"
export * from "./MainIndicators.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__